module.exports = __webpack_public_path__ + "img/dea-logo.fbd9b8eb.svg";